export default __webpack_public_path__ + "static/media/pallete_blue.9732125f.svg";